import React, { useEffect, useRef } from 'react';
import './Cursor.css';

const Cursor: React.FC = () => {
  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);
  const dotRef   = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let mx = 0, my = 0;   // mouse position
    let ox = 0, oy = 0;   // outer arrow lagged position
    let raf: number;

    const onMove = (e: MouseEvent) => {
      mx = e.clientX;
      my = e.clientY;

      // Inner arrow follows instantly
      if (innerRef.current) {
        innerRef.current.style.transform = `translate(${mx}px, ${my}px)`;
      }
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mx - 2}px, ${my - 2}px)`;
      }
    };

    // Outer ghost arrow lags behind with lerp
    const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

    const animate = () => {
      ox = lerp(ox, mx, 0.1);
      oy = lerp(oy, my, 0.1);
      if (outerRef.current) {
        outerRef.current.style.transform = `translate(${ox}px, ${oy}px)`;
      }
      raf = requestAnimationFrame(animate);
    };

    // Hover effects — expand outer on interactive elements
    const onEnter = () => {
      innerRef.current?.classList.add('cursor--hover');
      outerRef.current?.classList.add('cursor--hover');
      dotRef.current?.classList.add('cursor--hover');
    };
    const onLeave = () => {
      innerRef.current?.classList.remove('cursor--hover');
      outerRef.current?.classList.remove('cursor--hover');
      dotRef.current?.classList.remove('cursor--hover');
    };

    const interactables = document.querySelectorAll(
      'a, button, .service-card, .project-card, .team-card, .nav__cta, .pillar'
    );
    interactables.forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });

    window.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
      interactables.forEach(el => {
        el.removeEventListener('mouseenter', onEnter);
        el.removeEventListener('mouseleave', onLeave);
      });
    };
  }, []);

  return (
    <>
      {/* Outer ghost arrow — lags behind */}
      <div ref={outerRef} className="cursor cursor--outer">
        <div className="cursor__arrow cursor__arrow--ghost" />
      </div>

      {/* Inner solid arrow — follows instantly */}
      <div ref={innerRef} className="cursor cursor--inner">
        <div className="cursor__arrow cursor__arrow--solid" />
      </div>

      {/* Tiny dot at tip */}
      <div ref={dotRef} className="cursor cursor--dot" />
    </>
  );
};

export default Cursor;